import { memo } from "react"

export const ErrorMessage = memo(({ children }) => {
  return <div className="flex h-screen flex-col items-center justify-center text-red-400">{children}</div>
})
